module.exports = __webpack_public_path__ + "img/Parallax.eaeddbd6.jpg";